import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { documentFileUpload , AddDocumentsandStatus} from "../../../Containers/OnBoarding/slice";
import { responsiveValue } from "../../../theme/Styles/responsiveValue";
import LoadingButton from "@mui/lab/LoadingButton";
import { DocumentStatus } from "../../../common/enum";
import { useSearchParams, Link as RouterLink } from "react-router-dom";

import {
  Typography,
  Box,
  Stack,
  Paper,
  Button,
  TextField,
  CircularProgress, // Import CircularProgress from MUI
} from "@mui/material";

import { FormProvider } from "../../../components/hook-form";
import logo from "../../../logo.svg";
import { checksEmailExist, forgotPassword } from "../../../redux/features/authSlice";
import { useSnackbar } from "notistack";

const VerifyDocuments = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [onSuccess, setOnSuccess] = useState(false);
  const [businessRegistration, setBusinessRegistration] = useState(null);
  const [mandatedStatement, setMandatedStatement] = useState(null);
  const [businessRegPercentage, setbusinessRegPercentage] = useState(0);
  const [businessRegistrationUri, setBusinessRegistrationUri] = useState(null);
  const [mandatePercentage, setMandatePercentage] = useState(0);
  const [mandatedStatementUri, setMandatedStatementUri] = useState(null);
  const [businessRegError, setBusinessRegError] = useState(false);
  const [searchParams] = useSearchParams();
  const verifyToken = searchParams.get("verify");
  const type = searchParams.get("type");
  const { t } = useTranslation();
  
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({
      // Define your form validation schema here
      email: Yup.string().email().required(),
    })),
    defaultValues: {
      // Define default values for your form fields here
      businessRegistration: '',
      mandatedStatement: '',
    },
  });

  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }

  const uploadDocumnetDetails = async (filetype, fileName) => {
    const date = new Date().setFullYear(new Date().getFullYear() + 2);
    const documentDetails = {
      loggedInUserId: verifyToken,
      entityId: verifyToken,
      updatedBy: verifyToken,
      status: DocumentStatus.waitingForValidation,
      fileType: filetype,
      fileName: fileName,
      expiryDate: toLocalISOString(new Date(date))
    };
    await dispatch(AddDocumentsandStatus(documentDetails));
  };

  const { handleSubmit, setError } = methods;
  const businessRegistrationRef = React.useRef();
  const mandatedStatementRef = React.useRef();

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setbusinessRegPercentage(percent);
    }
  };
  const handleSubmitDocument = React.useCallback(async () => {
   // setLoading(true);
      try {
        if (businessRegistrationUri !== null && businessRegistrationUri.length > 0) {
          await uploadDocumnetDetails(
            "BUSINESS_REGISTRATION",
            businessRegistrationUri
          );
        }
        if (mandatedStatementUri !== null && mandatedStatementUri.length > 0) {
          await uploadDocumnetDetails(
            "MANDATED_STATEMENT",
            mandatedStatementUri
          );
        }

        enqueueSnackbar({
          message: "Documento(s) carregado(s) com sucesso",
          variant: "success",
          autoHideDuration: 3000,
        });
        setOnSuccess(true)
      } catch (err) {
        enqueueSnackbar({
          message: "Algo deu errado, tente novamente maos tarde",
          variant: "error",
          autoHideDuration: 3000,
        });
        console.error(err);
      }
  }, [businessRegistrationUri,mandatedStatementUri]);


  const onUploadProgressMandate = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setMandatePercentage(percent);
    }
  };
  const onSubmit = async (data) => {
    dispatch(checksEmailExist(data.email))
      .unwrap()
      .then((res) => {
        setOnSuccess(true);
        dispatch(forgotPassword({ data }));
      })
      .catch((err) => {
        setOnSuccess(false);
        setError("email", {
          type: "emailfail",
          message: t("pleaseEnterTheRegisteredEmail"),
        });
      });
  };

  const handleBusinessFileUpload = React.useCallback((e) => {
    setBusinessRegError(false);
    const data = new FormData();
    data.append("file", e.target.files[0]);
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        setBusinessRegistrationUri(res.fileName);
        setbusinessRegPercentage(100);
        setTimeout(() => {
          setbusinessRegPercentage(0);
        }, 1000);
        setBusinessRegistration(e.target.files?.item(0).name);
      })
      .catch((error) => {
       // console.log(error);
      });

    if (businessRegistrationRef.current) {
      businessRegistrationRef.current.focus();
    }
  }, []);

  const handleMandateFileUpload = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const onUploadProgress = onUploadProgressMandate;
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        setMandatedStatementUri(res.fileName);
        setMandatePercentage(100);
        setTimeout(() => {
          setMandatePercentage(0);
        }, 1000);
        setMandatedStatement(e.target.files?.item(0).name);
      })
      .catch((error) => {
       // console.log(error);
      });
    if (mandatedStatementRef.current) {
      mandatedStatementRef.current.focus();
    }
  }, []);

  const style = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Stack sx={style}>
      <Box sx={{ textAlign: "center" }}>
        <Box mb={8} mt={2} pr={4}>
          <img src={logo} alt="Tomaládácá logotipo" />
        </Box>

        <Paper variant="outlined" sx={{ maxWidth: 550, padding: "16px", borderRadius: "10px" }}>
          {onSuccess === false ? (
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Paper sx={{ p: "20px" }}>
                <Typography>{"Documentos"}</Typography>
                {type == "1" && (
                   <Controller
                   name="businessRegistration"
                   control={methods.control}
                   defaultValue={[]}
                   render={({
                     field: { ref, ...field },
                     fieldState: { error },
                   }) => (
                     <TextField
                       id="outlined-basic"
                       label={t("businessRegistration")}
                       variant="outlined"
                       inputRef={businessRegistrationRef}
                       value={
                         businessRegistration !== null
                           ? businessRegistration
                           : ""
                       }
                       sx={{ marginTop: "20px" }}
                       name="businessRegistration"
                       helperText={error?.message}
                       error={error}
                       InputProps={{
                         readOnly: true,
                         endAdornment: (
                           <>
                             {businessRegPercentage === 0 && (
                               <Button
                                 variant="contained"
                                 aria-label="upload"
                                 component="label"
                                 sx={{ borderRadius: "4px" }}
                               >
                                  {'Selecionar'}
                                 <input
                                   hidden
                                   accept=".pdf"
                                   id="choose-file"
                                   type="file"
                                   onChange={(e) => {
                                     const selectedFile = e.target.files[0];
                                     if (selectedFile) {
                                       const fileType = selectedFile.type;
                                       if (fileType === "application/pdf") {
                                         handleBusinessFileUpload(e);
                                         field.onChange(e.target.files);
                                       }else{
                                         enqueueSnackbar({
                                           variant: "error",
                                           message: "Selecione um ficheiro tipo pdf para o registo comercial",
                                         });
                                       }
                                     }
                                     
                                   }}
                                 />
                               </Button>
                             )}
                             {businessRegPercentage > 0 && (
                               <CircularProgress
                                 variant="determinate"
                                 value={businessRegPercentage}
                               />
                             )}
                           </>
                         ),
                       }}
                       fullWidth
                     />
                   )}
                 />
                )}
               {type == "2" &&(
                <Controller
                      name="mandatedStatement"
                      control={methods.control}
                      defaultValue={[]}
                      render={({
                        field: { ref, ...field },
                        fieldState: { error },
                      }) => (
                        <TextField
                          id="outlined-basic"
                          label={t("mandatedStatement")}
                          variant="outlined"
                          inputRef={mandatedStatementRef}
                          value={
                            mandatedStatement !== null ? mandatedStatement : ""
                          }
                          sx={{ marginTop: "20px" }}
                          name="mandatedStatement"
                          helperText={error?.message}
                          error={error}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <>
                                {mandatePercentage === 0 && (
                                  <Button
                                    variant="contained"
                                    aria-label="upload"
                                    component="label"
                                    sx={{ borderRadius: "4px" }}
                                  >
                                     {'Selecionar'}
                                    <input
                                      hidden
                                      accept=".pdf"
                                      id="choose-file"
                                      type="file"
                                      onChange={(e) => {
                                        const selectedFile = e.target.files[0];
                                        if (selectedFile) {
                                          const fileType = selectedFile.type;
                                          if (fileType === "application/pdf") {
                                            handleMandateFileUpload(e);
                                            field.onChange(e.target.files);
                                          }else{
                                            enqueueSnackbar({
                                              variant: "error",
                                              message: "Selecione um ficheiro tipo pdf para a declaração mandatada",
                                            });
                                          }
                                        }
                                       
                                      }}
                                    />
                                  </Button>
                                )}
                                {mandatePercentage > 0 && (
                                  <CircularProgress
                                    variant="determinate"
                                    value={mandatePercentage}
                                  />
                                )}
                              </>
                            ),
                          }}
                          fullWidth
                        />
                      )}
                    />
               )}

               {type == "3" &&(
                <>
                <Controller
                   name="businessRegistration"
                   control={methods.control}
                   defaultValue={[]}
                   render={({
                     field: { ref, ...field },
                     fieldState: { error },
                   }) => (
                     <TextField
                       id="outlined-basic"
                       label={"Registo Comercial"}
                       variant="outlined"
                       inputRef={businessRegistrationRef}
                       value={
                         businessRegistration !== null
                           ? businessRegistration
                           : ""
                       }
                       sx={{ marginTop: "20px" }}
                       name="businessRegistration"
                       helperText={error?.message}
                       error={error}
                       InputProps={{
                         readOnly: true,
                         endAdornment: (
                           <>
                             {businessRegPercentage === 0 && (
                               <Button
                                 variant="contained"
                                 aria-label="upload"
                                 component="label"
                                 sx={{ borderRadius: "4px" }}
                               >
                                  {'Selecionar'}
                                 <input
                                   hidden
                                   accept=".pdf"
                                   id="choose-file"
                                   type="file"
                                   onChange={(e) => {
                                     const selectedFile = e.target.files[0];
                                     if (selectedFile) {
                                       const fileType = selectedFile.type;
                                       if (fileType === "application/pdf") {
                                         handleBusinessFileUpload(e);
                                         field.onChange(e.target.files);
                                       }else{
                                         enqueueSnackbar({
                                           variant: "error",
                                           message: "Selecione um ficheiro tipo pdf para o registo comercial",
                                         });
                                       }
                                     }
                                     
                                   }}
                                 />
                               </Button>
                             )}
                             {businessRegPercentage > 0 && (
                               <CircularProgress
                                 variant="determinate"
                                 value={businessRegPercentage}
                               />
                             )}
                           </>
                         ),
                       }}
                       fullWidth
                     />
                   )}
                 />
                    <Controller
                      name="mandatedStatement"
                      control={methods.control}
                      defaultValue={[]}
                      render={({
                        field: { ref, ...field },
                        fieldState: { error },
                      }) => (
                        <TextField
                          id="outlined-basic"
                          label={"Declaração mandatada"}
                          variant="outlined"
                          inputRef={mandatedStatementRef}
                          value={
                            mandatedStatement !== null ? mandatedStatement : ""
                          }
                          sx={{ marginTop: "20px" }}
                          name="mandatedStatement"
                          helperText={error?.message}
                          error={error}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <>
                                {mandatePercentage === 0 && (
                                  <Button
                                    variant="contained"
                                    aria-label="upload"
                                    component="label"
                                    sx={{ borderRadius: "4px" }}
                                  >
                                     {'Selecionar'}
                                    <input
                                      hidden
                                      accept=".pdf"
                                      id="choose-file"
                                      type="file"
                                      onChange={(e) => {
                                        const selectedFile = e.target.files[0];
                                        if (selectedFile) {
                                          const fileType = selectedFile.type;
                                          if (fileType === "application/pdf") {
                                            handleMandateFileUpload(e);
                                            field.onChange(e.target.files);
                                          }else{
                                            enqueueSnackbar({
                                              variant: "error",
                                              message: "Selecione um ficheiro tipo pdf para a declaração mandatada",
                                            });
                                          }
                                        }
                                       
                                      }}
                                    />
                                  </Button>
                                )}
                                {mandatePercentage > 0 && (
                                  <CircularProgress
                                    variant="determinate"
                                    value={mandatePercentage}
                                  />
                                )}
                              </>
                            ),
                          }}
                          fullWidth
                        />
                      )}
                    />
                    </>
               )}
                    
          <LoadingButton
          sx={{
            mt :3,
            marginRight: responsiveValue("", "", "", "0px", "0px", "10px"),
            borderRadius:'4px'
          }}
          size="large"
          variant="contained"
          onClick={handleSubmitDocument}
        >
          <Typography variant="bold">{"Submeter"}</Typography>
        </LoadingButton>
              </Paper>
              
            </FormProvider>
            
          ) : (
            <>
              <Typography pb={4} fontWeight="400" variant="h3">
                {"Os documentos submetidos foram atualizados e o seu pedido encontra-se em análise."}
              </Typography>
              <Button
                to="/"
                size="large"
                variant="contained"
                component={RouterLink}
                sx={{
                  textTransform: "none",
                  "&:hover": {
                    color: "#ffffff",
                  },
                  borderRadius: "4px",
                }}
              >
                {"Voltar ao início"}
              </Button>
            </>
          )}
          
        </Paper>
      </Box>
     
    </Stack>
  );
};

export default VerifyDocuments;